'use strict'

import langScreen from './templates/lang.template.html'
import indexScreen from './templates/index.template.html'

export default function ( $scope, $templateCache, Langs, $timeout, $location )
{
	const vm = this,
		screens =
			{
				lang: langScreen,
				index: indexScreen
			}

	let $scroll = null

	vm.lang = window.localStorage.getItem('lang') || null	
	vm.current = (vm.lang === null) ? 1 : 2
	vm.angle = 0
	vm._ = Langs.get(vm.lang)
	vm.bg = 'none'

	$scope._ = function ( key )
		{
			return vm._[key]
		}

	vm.langs = ['Ru','En','Es']
	vm.bgs = [
		'none',
		'city',
		'pixel',
		'cosplay',
		'expo',
		'fair',
		'none'
	]

	vm.partners = 
		[
			{
				url: 'http://verve.space',
				title: 'verveunion',
				image: 'verve-union.png'
			},
			{
				url: 'https://mol36.ru',
				title: 'ryc',
				image: 'dom-molodezhy.png'
			},
			{
				url: 'http://retroscene.org',
				title: 'retroscene',
				image: 'retroscene-org.png'
			},
			{
				url: 'http://chipwiki.ru',
				title: 'chipwiki',
				image: 'chipwiki.png'
			},
			{
				url: 'https://vk.com/pixel.arts',
				title: 'dotpixel',
				image: 'pixel-arts.png'
			},
			{
				url: 'https://vk.com/geek_squad_club',
				title: 'geeksquad',
				image: 'geek-squad.png'
			},
			{
				url: 'https://vk.com/golosvremen',
				title: 'golosvremen',
				image: 'golos-vremen.png'
			},
			{
				url: 'https://vk.com/komnatnyydrakon',
				title: 'homedragon',
				image: 'home-dragon.png'
			}
		]

	vm.pages = 
		[
			{
				content: 'lang',
				bg: ['dino.jpg', 90]
			},
			{
				content: 'index',
				bg: ['none', -90]
			}
		]

	vm.flush = function ()
		{
			window.localStorage.setItem('lang', '')
			vm.current = 1
		}

	vm.format = function ( data )
		{
			var img = (data[0] === 'none') 
				? 'background-image: ' + vm.bg
				: 'background-image: url(/img/screens/' + data[0] + ')'

			;(!data[2]) && (data[2] = 'cover')
			vm.angle = data[1]

			return img + '; background-size: ' + data[2]
		}

	vm.set = function ( lang )
		{
			vm.lang = lang.toLowerCase()
			vm._ = Langs.get(lang)
			window.localStorage.setItem('lang', lang.toLowerCase())
			vm.current = 2
		}

	vm.scrollTo = function ( id )
		{
			var $to = document.getElementById(id),
				$scroll = document.querySelector('.page-2 .content'),
				step

			if ($to === null) return

			step = ($to.offsetTop - $scroll.scrollTop) / 50

			_step()

			function _step ()
			{
				$scroll.scrollTop += step
				if ($scroll.scrollTop >= $scroll.scrollHeight - window.innerHeight - 20) {
					$scroll.scrollTop = $scroll.scrollHeight
					return
				}

				;(step > 0)
					? ($scroll.scrollTop < $to.offsetTop) ? ($timeout(_step, 1)) : $scroll.scrollTop = $to.offsetTop
					: ($scroll.scrollTop > $to.offsetTop) ? ($timeout(_step, 1)) : $scroll.scrollTop = $to.offsetTop
			}
		}

	defineTemplates()
	waitForScroll()
	$timeout(function(){
		document.body.style.opacity = 1
	}, 1000)

	function defineTemplates()
		{
			for (let i = 0; i < vm.pages.length; i++)
			{
				$templateCache.put(vm.pages[i].content, screens[vm.pages[i].content])
			}
		}

	function waitForScroll ()
		{
			$scroll = document.querySelector('.page-2 .content')

			;($scroll !== null)
				? initScroll()
				: $timeout(waitForScroll, 100)
		}

	function initScroll ()
		{
			$scroll.addEventListener('scroll', function ( e ){
				vm.angle = Math.round(($scroll.scrollTop / $scroll.scrollHeight) * 360)
				vm.bg = vm.bgs[Math.floor(($scroll.scrollTop + window.innerHeight / 2) / window.innerHeight)]
				;(vm.bg === 'none') 
					? vm.bg = 'url(/img/screens/none.png)'
					: vm.bg = 'url(/img/screens/' + vm.bg + '.jpg)'

				$scope.$apply()

				document.body.style.background = 'linear-gradient(' + vm.angle + 'deg, #6b4bb7 0%,#177da6 100%)'
			})
		}
}


// WEBPACK FOOTER //
// ./src/app/pages/index/index.controller.js